// Content: golden pumpernickel random buff variants.
export const GOLDEN_BUFFS = [
  { id: 'g_frenzy',    copy: 'frenzy! x7 rate',           mult: 7 },
  { id: 'g_lucky',     copy: 'lucky streak. x3 rate',     mult: 3 },
  { id: 'g_double',    copy: 'double or nothing. x2',     mult: 2 },
  { id: 'g_overdrive', copy: 'overdrive. x10 rate',       mult: 10 },
  { id: 'g_fizzle',    copy: 'fizzle. x1.5 (it tried.)',  mult: 1.5 },
];
